/**
 * Environment Configuration
 * Centralized place for all environment variables
 */

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN || '',
} as const;
